import { render, staticRenderFns } from "./ProductAvailabilityTab.vue?vue&type=template&id=127e8478&scoped=true"
import script from "./ProductAvailabilityTab.vue?vue&type=script&lang=js"
export * from "./ProductAvailabilityTab.vue?vue&type=script&lang=js"
import style0 from "./ProductAvailabilityTab.vue?vue&type=style&index=0&id=127e8478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e8478",
  null
  
)

export default component.exports